export default "__VITE_ASSET__DI9nQYx0__"